import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "arrow",
  "use": "arrow-usage",
  "viewBox": "0 0 5 10",
  "content": "<symbol viewBox=\"0 0 5 10\" xmlns=\"http://www.w3.org/2000/svg\" id=\"arrow\">\n  <path d=\"M0.120359 1.3201C-0.0632215 1.10796 -0.0334573 0.792683 0.18684 0.615902C0.407136 0.43912 0.734544 0.467782 0.918125 0.67992L4.37965 4.67991C4.54012 4.86533 4.54012 5.13467 4.37965 5.32009L0.918125 9.32008C0.734544 9.53222 0.407136 9.56088 0.18684 9.3841C-0.0334573 9.20732 -0.0632215 8.89204 0.120359 8.6799L3.30489 5L0.120359 1.3201Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol